export const MESSAGE_CODE_SYSTEM_BUSY = 10000
export const MESSAGE_CODE_INPUT_DATA_ERROR = 10001

export const MESSAGE_CODE_AUTH_PLEASE_LOGIN_STAFF_ACCOUNT = 11000
export const MESSAGE_CODE_AUTH_LOGIN_FAIL = 11001
export const MESSAGE_CODE_AUTH_ACCOUNT_NOT_EXIST = 11002
export const MESSAGE_CODE_AUTH_ACCOUNT_EMAIL_NOT_VALIDATE = 11003

export const MESSAGE_CODE_SCOOTER_VIN_HAS_BEEN_USED = 20000
export const MESSAGE_CODE_SCOOTER_VIN_OUT_OF_STOCK = 20001
export const MESSAGE_CODE_SCOOTER_VIN_INCONSISTENT = 20002
export const MESSAGE_CODE_SCOOTER_FIND_NO_SCOOTER_DATA = 20003
export const MESSAGE_CODE_FIND_NO_SCOOTER = 20006
export const MESSAGE_CODE_VIN_IN_OTHER_ORDER = 20007
export const MESSAGE_CODE_VIN_NOT_IN_THIS_COMPANY = 20008
export const MESSAGE_CODE_VIN_IN_OTHER_STORE = 20009
export const MESSAGE_CODE_VIN_IN_CONTRACT = 20010
export const MESSAGE_CODE_FIND_NO_VIN = 20011
export const MESSAGE_CODE_SCOOTER_NOT_ON_SALE = 20012
export const MESSAGE_CODE_SCOOTER_IS_PENDING_AVAILABILITY_OR_OFF_SALE = 20013
export const MESSAGE_CODE_SCOOTER_PRODUCT_MISMATCH = 20014

export const MESSAGE_CODE_ORDER_NOT_FOUND = 30000
export const MESSAGE_CODE_ORDER_NUMBER_EMPTY = 30001
export const MESSAGE_CODE_ORDER_PLAN_CODE_EMPTY = 30002
export const MESSAGE_CODE_ORDER_MODIFY_FAILED = 30003
export const MESSAGE_CODE_ORDER_SHOPPING_CART_EMPTY = 30004
export const MESSAGE_CODE_ORDER_ITEM_HAS_BOUGHT = 30005
export const MESSAGE_CODE_ORDER_ITEM_DOES_NOT_SUPPORT_YOUR_SCOOTER = 30006
export const MESSAGE_CODE_ORDER_CANNOT_FIND_SCOOTER_LICENCE_PLATE_NUMBER = 30007
export const MESSAGE_CODE_ORDER_THE_ACCOUNT_DOES_NOT_HAS_ANY_SCOOTER = 30008
export const MESSAGE_CODE_ORDER_HAS_INVOICE_AWAITING_CALCELLATION = 30016
export const MESSAGE_CODE_CREATE_ORDER_PERMISSION_NOT_MATCH = 30017
export const MESSAGE_CODE_UNABLE_EDIT_ORDER = 30019
export const MESSAGE_CODE_PICK_NUMBER_SERVICE_ERROR = 30020

export const MESSAGE_CODE_ORDER_CANNOT_COMBINE_USED = 31000
export const MESSAGE_CODE_ORDER_COUPON_CODE_CANNOT_BE_NULL = 31001
export const MESSAGE_CODE_ORDER_COUPON_SERIAL_CANNOT_BE_NULL = 31002
export const MESSAGE_CODE_ORDER_COUPON_SERIAL_NOT_EXIST = 31003
export const MESSAGE_CODE_ORDER_COUPON_SERIAL_HAS_BEEN_USED = 31004
export const MESSAGE_CODE_ORDER_NOT_REFUND = 31100
export const MESSAGE_CODE_ORDER_INVOICE_STATUS_NOT_CANCEL = 31101
export const MESSAGE_CODE_ORDER_CHT_SERIAL_ERROR = 31200
export const MESSAGE_CODE_ORDER_CHT_SERIAL_HAS_BEEN_USED = 31201
export const MESSAGE_CODE_ORDER_CHT_UPDATE_SERIAL_STATUS_ERROR = 31202
export const MESSAGE_CODE_ORDER_CHT_COUPON_DISCOUNT_AMOUNT_DIFFERENT_WITH_CAMPAIGN_AMOUNT = 31204
export const MESSAGE_CODE_ORDER_NOT_ALLOW_MANUALLY_ALLOCATE = 32000
export const MESSAGE_CODE_ORDER_CONTRACT_ALREADY_EXIST = 32001
export const MESSAGE_CODE_ORDER_CONFIRM_STATUS_IS_PAIRING = 32002
export const MESSAGE_CODE_ORDER_STOCK_POSITION_CANNOT_ALLOCATE_THIS_VIN = 32003
export const MESSAGE_CODE_ORDER_VIN_STATUS_CANNOT_ALLOCATE = 32004
export const MESSAGE_CODE_ORDER_CANNOT_ALLOCATE_VIN_AT_CURRENT_STORE = 32005
export const MESSAGE_CODE_ORDER_VIN_MATCH_MODEL_ERROR = 32006
export const MESSAGE_CODE_ORDER_STOCK_SHORT = 32007
export const MESSAGE_CODE_ORDER_CANNOT_DEALLOCATE_WHEN_ALREADY_HAS_LICENSE = 32008
export const MESSAGE_CODE_ORDER_STATUS_NOT_AVAILABLE_FOR_DEALLOCATION = 32009
export const MESSAGE_CODE_ORDER_PDI_PROCESSING_PLEASE_INFO_CENTER_TO_CANCEL = 32010
export const MESSAGE_CODE_ORDER_PDI_COMPLETE_AND_CANNOT_BE_CANCELLED = 32011
export const MESSAGE_CODE_ORDER_NO_CHANNEL_PRICE = 32012
export const MESSAGE_CODE_ORDER_NO_CHANNEL_PRICE_SETTING = 32013

export const MESSAGE_CODE_DELIVERY_DATE_LESS_THAN_SCHEDULE = 33001
export const MESSAGE_CODE_NO_DELIVERY_DATE_CANT_UPLOAD_ATTACH = 33002
export const MESSAGE_CODE_ORDER_PDI_ATTACH_NOT_FOUND = 33003

export const MESSAGE_CODE_ATTACH_FILE_TYPE_NOT_SUPPORTED = 34000
export const MESSAGE_CODE_ATTACH_FILE_EXTENSION_HAS_TO_BE_SAME = 34001
export const MESSAGE_CODE_BACK_ACCOUNT_FORMAT_ERROR = 34002
export const MESSAGE_CODE_DUPLICATE_APPROVAL_CASE_NUMBER = 34003
export const MESSAGE_CODE_PRODUCT_NOT_SALE = 36001
export const MESSAGE_CODE_UNABLE_TO_CHANGE_PRODUCT = 36002
export const MESSAGE_CODE_REMOVE_PRODUCT_FAILED = 36003
export const MESSAGE_CODE_PRODUCT_NOT_FOUND = 36004
export const MESSAGE_CODE_PRODUCT_FIND_NO_STOCK = 36005
export const MESSAGE_CODE_PRODUCT_CAN_NOT_ADD_WARRANTY = 36006
export const MESSAGE_CODE_GOGORO_WALLET_CANNOT_CHANGE_PRICE = 36007
export const MESSAGE_CODE_CROSS_COUNTRY_SUBSIDY_CANNOT_BE_CHANGED = 36008
export const MESSAGE_CODE_ORDER_MODIFICATION_CANNNOT_SELECT_SUBSIDY_COUNTRY = 36009

export const MESSAGE_CODE_BATCH_ORDER_CREATION_ERROR = 37000

export const MESSAGE_CODE_CREDIT_CARD_TRANSACTION_ABNORMAL = 40001
export const MESSAGE_CODE_CREDIT_CARD_TRANSACTION_PROCESSING = 40002
export const MESSAGE_CODE_CREDIT_CARD_INSUFFICIENT_BALANCE = 40003
export const MESSAGE_CODE_CREDIT_CARD_TRANSACTION_OUTDATED = 40004
export const MESSAGE_CODE_CREDIT_CARD_INVALID_CARD = 40005
export const MESSAGE_CODE_CREDIT_CARD_REJECTED_CARD = 40006
export const MESSAGE_CODE_CREDIT_CARD_FAIL_CARD = 40007
export const MESSAGE_CODE_CREDIT_CARD_ASK_CARD_BANK = 40008
export const MESSAGE_CODE_CREDIT_CARD_VALID_DATE_FORMAT_ERROR = 40009
export const MESSAGE_CODE_CREDIT_CARD_AUTH_ERROR = 40010
export const MESSAGE_CODE_CREDIT_CARD_INSTALLMENT_ABNORMAL = 40011
export const MESSAGE_CODE_CREDIT_CARD_ORDER_NUBMER_REPEAT = 40012
export const MESSAGE_CODE_CREDIT_CARD_TRANSACTION_TIMEOUT = 40013
export const MESSAGE_CODE_CREDIT_CARD_TRANSACTION_REFUSE = 40014
export const MESSAGE_CODE_CREDIT_CARD_QRCODE_TIMEOUT = 40015
export const MESSAGE_CODE_CREDIT_CARD_THIRD_PARTY_PLATFORM_ABNORMAL = 40016
export const MESSAGE_CODE_CREDIT_CARD_REPEAT_PAY = 40017
export const MESSAGE_CODE_WALLET_PAY_FAILED = 41000
export const MESSAGE_CODE_WALLET_REFUND_FAILED = 41001
export const MESSAGE_CODE_WALLET_RESCAN_QR_CODE = 41002
export const MESSAGE_CODE_BATTERY_CONTRACT_NOT_FOUND = 50000
export const MESSAGE_CODE_BATTERY_AND_PLAN_NOT_MATCH = 50003
export const MESSAGE_CODE_NO_SUBSCRIPTION_PLAN = 50004

export const MESSAGE_CODE_TRANSFER_SCOOTER_ABNORMAL = 60000
export const MESSAGE_CODE_TRANSFER_SCOOTER_CONFIRM_ATTACH_ITEM_HAS_BEEN_SELECTED = 60001
export const MESSAGE_CODE_TRANSFER_SCOOTER_IS_IN_PROGRESS = 60002
export const MESSAGE_CODE_TRANSFER_SCOOTER_APPLICATION_FAILED = 60003
export const MESSAGE_CODE_TRANSFER_SCOOTER_COMPLETED_BUT_MAIL_NOTIFICATION_FAILED = 60004
export const MESSAGE_CODE_OWNER_INFORMATION_NOT_FOUND = 60005

export const MESSAGE_CODE_STORE_MANAGEMENT_STORE_SETTING_ABNORMAL = 70000
export const MESSAGE_CODE_STORE_MANAGEMENT_GROUP_SETTING_ABNORMAL = 70001

export const salesMessageCodeMap = new Map([
  [MESSAGE_CODE_SYSTEM_BUSY, "system_is_busy"],
  [MESSAGE_CODE_INPUT_DATA_ERROR, "input_data_error"],
  [MESSAGE_CODE_AUTH_PLEASE_LOGIN_STAFF_ACCOUNT, "please_login_staff_account"],
  [MESSAGE_CODE_AUTH_LOGIN_FAIL, "login_fail"],
  [MESSAGE_CODE_AUTH_ACCOUNT_NOT_EXIST, "account_not_exist"],
  [MESSAGE_CODE_AUTH_ACCOUNT_EMAIL_NOT_VALIDATE, "account_email_not_validate"],
  [MESSAGE_CODE_SCOOTER_VIN_HAS_BEEN_USED, "vin_has_been_used"],
  [MESSAGE_CODE_SCOOTER_VIN_OUT_OF_STOCK, "vin_out_of_stock"],
  [MESSAGE_CODE_SCOOTER_VIN_INCONSISTENT, "vin_inconsistent"],
  [MESSAGE_CODE_SCOOTER_FIND_NO_SCOOTER_DATA, "find_no_scooter_data"],
  [MESSAGE_CODE_FIND_NO_VIN, "find_no_vin"],
  [MESSAGE_CODE_SCOOTER_NOT_ON_SALE, "vin_scooter_unavailable"],
  [MESSAGE_CODE_SCOOTER_IS_PENDING_AVAILABILITY_OR_OFF_SALE, "scooter_pending_availability_or_off_sale"],
  [MESSAGE_CODE_SCOOTER_PRODUCT_MISMATCH, "scooter_product_mismatch"],
  [MESSAGE_CODE_VIN_IN_OTHER_ORDER, "vin_in_other_order"],
  [MESSAGE_CODE_VIN_NOT_IN_THIS_COMPANY, "vin_not_in_this_company"],
  [MESSAGE_CODE_VIN_IN_OTHER_STORE, "vin_in_other_store"],
  [MESSAGE_CODE_VIN_IN_CONTRACT, "vin_in_contract"],
  [MESSAGE_CODE_ORDER_HAS_INVOICE_AWAITING_CALCELLATION, "order_has_invoice_awaiting_cancellation"],
  [MESSAGE_CODE_CREATE_ORDER_PERMISSION_NOT_MATCH, "create_order_permission_not_match"],
  [MESSAGE_CODE_UNABLE_EDIT_ORDER, "unable_edit_order"],
  [MESSAGE_CODE_PICK_NUMBER_SERVICE_ERROR, "pick_number_service_error"],
  [MESSAGE_CODE_ORDER_NOT_FOUND, "order_not_found"],
  [MESSAGE_CODE_ORDER_NUMBER_EMPTY, "order_number_empty"],
  [MESSAGE_CODE_ORDER_PLAN_CODE_EMPTY, "order_plan_code_empty"],
  [MESSAGE_CODE_ORDER_MODIFY_FAILED, "order_modify_failed"],
  [MESSAGE_CODE_ORDER_SHOPPING_CART_EMPTY, "order_shopping_cart_empty"],
  [MESSAGE_CODE_ORDER_ITEM_HAS_BOUGHT, "order_item_has_bought"],
  [MESSAGE_CODE_ORDER_ITEM_DOES_NOT_SUPPORT_YOUR_SCOOTER, "order_item_does_not_support_your_scooter"],
  [MESSAGE_CODE_ORDER_CANNOT_FIND_SCOOTER_LICENCE_PLATE_NUMBER, "order_cannot_find_scooter_licence_plate_number"],
  [MESSAGE_CODE_ORDER_THE_ACCOUNT_DOES_NOT_HAS_ANY_SCOOTER, "order_the_account_does_not_has_any_scooter"],
  [MESSAGE_CODE_ORDER_CANNOT_COMBINE_USED, "order_cannot_combine_used"],
  [MESSAGE_CODE_ORDER_COUPON_CODE_CANNOT_BE_NULL, "order_coupon_code_cannot_be_null"],
  [MESSAGE_CODE_ORDER_COUPON_SERIAL_CANNOT_BE_NULL, "order_coupon_serial_cannot_be_null"],
  [MESSAGE_CODE_ORDER_COUPON_SERIAL_NOT_EXIST, "order_coupon_serial_not_exist"],
  [MESSAGE_CODE_ORDER_COUPON_SERIAL_HAS_BEEN_USED, "order_coupon_serial_has_been_used"],
  [MESSAGE_CODE_ORDER_NOT_REFUND, "order_not_refund_cannot_return_gift"],
  [MESSAGE_CODE_ORDER_INVOICE_STATUS_NOT_CANCEL, "order_invoice_status_not_cancel_cannot_return_gift"],
  [MESSAGE_CODE_ORDER_CHT_SERIAL_ERROR, "order_cht_serial_error"],
  [MESSAGE_CODE_ORDER_CHT_SERIAL_HAS_BEEN_USED, "order_cht_serial_has_been_used"],
  [MESSAGE_CODE_ORDER_CHT_UPDATE_SERIAL_STATUS_ERROR, "order_cht_update_serial_status_error"],
  [
    MESSAGE_CODE_ORDER_CHT_COUPON_DISCOUNT_AMOUNT_DIFFERENT_WITH_CAMPAIGN_AMOUNT,
    "order_cht_coupon_discount_amount_different_with_campaign_amount",
  ],
  [MESSAGE_CODE_ORDER_NOT_ALLOW_MANUALLY_ALLOCATE, "order_not_allow_manually_allocate"],
  [MESSAGE_CODE_ORDER_CONTRACT_ALREADY_EXIST, "order_contract_already_exist"],
  [MESSAGE_CODE_ORDER_CONFIRM_STATUS_IS_PAIRING, "order_confirm_status_is_pairing"],
  [MESSAGE_CODE_ORDER_STOCK_POSITION_CANNOT_ALLOCATE_THIS_VIN, "order_stock_position_cannot_allocate_this_vin"],
  [MESSAGE_CODE_ORDER_VIN_STATUS_CANNOT_ALLOCATE, "order_vin_status_cannot_allocate"],
  [MESSAGE_CODE_ORDER_CANNOT_ALLOCATE_VIN_AT_CURRENT_STORE, "order_cannot_allocate_vin_at_current_store"],
  [MESSAGE_CODE_ORDER_VIN_MATCH_MODEL_ERROR, "order_vin_match_model_error"],
  [MESSAGE_CODE_ORDER_STOCK_SHORT, "order_stock_short"],
  [MESSAGE_CODE_ORDER_CANNOT_DEALLOCATE_WHEN_ALREADY_HAS_LICENSE, "order_cannot_deallocate_when_already_has_license"],
  [MESSAGE_CODE_ORDER_STATUS_NOT_AVAILABLE_FOR_DEALLOCATION, "order_status_not_available_for_deallocation"],
  [MESSAGE_CODE_DELIVERY_DATE_LESS_THAN_SCHEDULE, "delivery_date_less_than_schedule"],
  [MESSAGE_CODE_ORDER_PDI_PROCESSING_PLEASE_INFO_CENTER_TO_CANCEL, "pdi_processing_please_info_center_to_cancel"],
  [MESSAGE_CODE_ORDER_PDI_COMPLETE_AND_CANNOT_BE_CANCELLED, "pdi_complete_and_cannot_be_cancelled"],
  [MESSAGE_CODE_ORDER_NO_CHANNEL_PRICE, "order_no_channel_price"],
  [MESSAGE_CODE_ORDER_NO_CHANNEL_PRICE_SETTING, "order_no_channel_price_setting"],
  [MESSAGE_CODE_FIND_NO_SCOOTER, "find_no_scooter"],
  [MESSAGE_CODE_PRODUCT_NOT_SALE, "product_not_sale"],
  [MESSAGE_CODE_UNABLE_TO_CHANGE_PRODUCT, "product_unable_select"],
  [MESSAGE_CODE_ATTACH_FILE_TYPE_NOT_SUPPORTED, "attach_file_type_not_supported"],
  [MESSAGE_CODE_REMOVE_PRODUCT_FAILED, "remove_product_failed"],
  [MESSAGE_CODE_PRODUCT_NOT_FOUND, "product_not_found"],
  [MESSAGE_CODE_PRODUCT_FIND_NO_STOCK, "product_find_no_stock"],
  [MESSAGE_CODE_ATTACH_FILE_EXTENSION_HAS_TO_BE_SAME, "attach_file_extension_has_to_be_same"],
  [MESSAGE_CODE_BACK_ACCOUNT_FORMAT_ERROR, "bank_account_format_error"],
  [MESSAGE_CODE_DUPLICATE_APPROVAL_CASE_NUMBER, "duplicate_approval_case_number_error"],
  [MESSAGE_CODE_CREDIT_CARD_TRANSACTION_ABNORMAL, "credit_card_transaction_abnormal"],
  [MESSAGE_CODE_CREDIT_CARD_TRANSACTION_PROCESSING, "credit_card_transaction_processing"],
  [MESSAGE_CODE_CREDIT_CARD_INSUFFICIENT_BALANCE, "credit_card_insufficient_balance"],
  [MESSAGE_CODE_CREDIT_CARD_TRANSACTION_OUTDATED, "credit_card_transaction_outdated"],
  [MESSAGE_CODE_CREDIT_CARD_INVALID_CARD, "credit_card_invalid_card"],
  [MESSAGE_CODE_CREDIT_CARD_REJECTED_CARD, "credit_card_rejected_card"],
  [MESSAGE_CODE_CREDIT_CARD_FAIL_CARD, "credit_card_fail_card"],
  [MESSAGE_CODE_CREDIT_CARD_ASK_CARD_BANK, "credit_card_ask_card_bank"],
  [MESSAGE_CODE_CREDIT_CARD_VALID_DATE_FORMAT_ERROR, "credit_card_valid_date_format_error"],
  [MESSAGE_CODE_CREDIT_CARD_AUTH_ERROR, "credit_card_auth_error"],
  [MESSAGE_CODE_CREDIT_CARD_INSTALLMENT_ABNORMAL, "credit_card_installment_abnormal"],
  [MESSAGE_CODE_CREDIT_CARD_ORDER_NUBMER_REPEAT, "credit_card_order_number_repeat"],
  [MESSAGE_CODE_CREDIT_CARD_TRANSACTION_TIMEOUT, "credit_card_transaction_timeout"],
  [MESSAGE_CODE_CREDIT_CARD_TRANSACTION_REFUSE, "credit_card_transaction_refuse"],
  [MESSAGE_CODE_CREDIT_CARD_QRCODE_TIMEOUT, "credit_card_qr_code_timeout"],
  [MESSAGE_CODE_CREDIT_CARD_THIRD_PARTY_PLATFORM_ABNORMAL, "credit_card_third_party_platform_abnormal"],
  [MESSAGE_CODE_CREDIT_CARD_REPEAT_PAY, "credit_card_repeat_pay"],
  [MESSAGE_CODE_WALLET_PAY_FAILED, "wallet_pay_failed"],
  [MESSAGE_CODE_WALLET_REFUND_FAILED, "wallet_refund_failed"],
  [MESSAGE_CODE_WALLET_RESCAN_QR_CODE, "wallet_rescan_qr_code"],
  [MESSAGE_CODE_BATTERY_CONTRACT_NOT_FOUND, "battery_contract_not_found"],
  [MESSAGE_CODE_BATTERY_AND_PLAN_NOT_MATCH, "battery_and_plan_not_match"],
  [
    MESSAGE_CODE_GOGORO_WALLET_CANNOT_CHANGE_PRICE,
    "wallet_order_cannot_change_events_which_cause_order_amount_changed",
  ],
  [MESSAGE_CODE_CROSS_COUNTRY_SUBSIDY_CANNOT_BE_CHANGED, "cross_country_subsidy_cannot_be_changed"],
  [MESSAGE_CODE_ORDER_MODIFICATION_CANNNOT_SELECT_SUBSIDY_COUNTRY, "cross_country_subsidy_cannot_be_changed"],

  [MESSAGE_CODE_TRANSFER_SCOOTER_ABNORMAL, "transfer_scooter_abnormal"],
  [
    MESSAGE_CODE_TRANSFER_SCOOTER_CONFIRM_ATTACH_ITEM_HAS_BEEN_SELECTED,
    "transfer_scooter_confirm_attach_item_has_been_selected",
  ],
  [MESSAGE_CODE_TRANSFER_SCOOTER_IS_IN_PROGRESS, "transfer_scooter_is_in_progress"],
  [MESSAGE_CODE_TRANSFER_SCOOTER_APPLICATION_FAILED, "transfer_scooter_application_failed"],
  [
    MESSAGE_CODE_TRANSFER_SCOOTER_COMPLETED_BUT_MAIL_NOTIFICATION_FAILED,
    "transfer_scooter_application_completed_but_email_notification_failed",
  ],
  [MESSAGE_CODE_OWNER_INFORMATION_NOT_FOUND, "owner_information_not_found"],
  [
    MESSAGE_CODE_STORE_MANAGEMENT_STORE_SETTING_ABNORMAL,
    "store_management_store_setting_is_abnormal_please_contact_headquarter",
  ],
  [
    MESSAGE_CODE_STORE_MANAGEMENT_GROUP_SETTING_ABNORMAL,
    "store_management_group_setting_is_abnormal_please_contact_headquarter",
  ],
  [MESSAGE_CODE_ORDER_PDI_ATTACH_NOT_FOUND, "order_pdi_attach_not_found"],
  [MESSAGE_CODE_BATCH_ORDER_CREATION_ERROR, "batch_order_creation_failed"],
])
